import { Component, computed, input, output } from '@angular/core';
import { AvatarComponent } from '@atoms/avatar/avatar.component';
import { getAvatarInitials } from '@utils/avatar.utils';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [AvatarComponent],
  templateUrl: './user-profile.component.html',
})
export class UserProfileComponent {
  readonly userName = input.required<string>();
  readonly avatarUrl = input<string>();
  readonly logout = output<void>();

  readonly avatar = computed(() => {
    const avatarUrl = this.avatarUrl();
    if (avatarUrl) {
      return avatarUrl;
    }
    const initials = getAvatarInitials(this.userName());
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Crect width='40' height='40' rx='20' fill='%236528f6'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dominant-baseline='central' fill='white' font-size='14' font-family='sans-serif'%3E${initials}%3C/text%3E%3C/svg%3E`;
  });

  onLogout(event: Event): void {
    event.preventDefault();
    this.logout.emit();
  }
}
